import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CustomFormsModule} from 'ng2-validation'
import {HttpModule, Http, XHRBackend, RequestOptions} from '@angular/http';
import {RouterModule, Router} from "@angular/router";
import {ToasterModule} from "angular2-toaster/angular2-toaster";
import {HttpProviderFactory} from './app.helpers';
import {ModalModule, TabsModule} from 'ng2-bootstrap';
import {ROUTES} from "./app.routes";
import {LayoutsModule} from "./components/common/layouts/layouts.module";
import {AppComponent} from './app.component';
import {LoginModule} from "./views/login/login.module";
import {ForgotPasswordModule} from "./views/forgot-password/forgot-password.module";
import {SetPasswordModule} from "./views/set-password/set-password.module";
import {EnterByTokenModule} from "./views/enter-by-token/enter.by.token.module";
import {ModalWinNewLeadModule} from "./views/modal-win-new-lead/win.module";
import {DashboardModule} from "./views/dashboard/dashboard.module";
//import {AdminsModule} from "./views/admins/admins.module";
import {ProfileModule} from "./views/profile/profile.module";
import {UsersModule} from "./views/users/users.module";
import {RoleModule} from "./views/role/role.module";
import {LeadModule} from "./views/leads/leads.module";
import {AuthGuard} from "./guards/auth.guard";
import {ApplicationUser} from "./services/ApplicationUser";
import {PermissionsService} from "./services/permissions/permissions.service";
import {FilePreviewModule} from "./views/file-preview/file-preview.module";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {DebtAccountModule} from "./modules/debt-account/debt-account.module";
import {StatementsModule} from "./modules/statements/statements.module";
import {FloatingButtonGlobalInfo_hidden} from './modules/floating-button/xservice';


@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        //Angular
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        CustomFormsModule,
        HttpModule,
        ToasterModule,
        ModalModule.forRoot(),
        TabsModule.forRoot(),
        NgbModule.forRoot(),

        //Views
        LoginModule,
        FilePreviewModule,
        ForgotPasswordModule,
        SetPasswordModule,
        EnterByTokenModule,
        ModalWinNewLeadModule,
        DashboardModule,
        //AdminsModule,
        ProfileModule,
        UsersModule,
        RoleModule,
        LeadModule,
        DebtAccountModule,
        StatementsModule,

        //Modules
        LayoutsModule,
        RouterModule.forRoot(ROUTES)
    ],
    providers: [
        AuthGuard,
        ApplicationUser,
        PermissionsService,
        FloatingButtonGlobalInfo_hidden,
        {
            provide: Http,
            useFactory: HttpProviderFactory,
            deps: [XHRBackend, RequestOptions, Router]
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts